import { defineComponent as _defineComponent } from 'vue'
import { useGetters } from 'vuex-composition-helpers'
import { formatDateTime, formatDateWithYear } from '@/utils/date-formatting'
import { ref, watch } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'
import moment from 'moment'
import { getById } from '@/api/locations'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmissionPrimitiveField',
  props: {
    lookup: null,
    format: null,
    value: { type: [String, Number, Boolean] }
  },
  setup(__props: any) {

const props = __props as {
  lookup: object & { entity?: string }
  format: string
  value: string | number | boolean
}



const { getBySid: getUserBySid } = useGetters('users', ['getBySid'])
const { getById: getCompanyById } = useGetters('companies', ['getById'])
const { getBusinessUnitById: getBusinessById } = useGetters('businessUnits', [
  'getBusinessUnitById',
])
const { getConditionById: getInventorySubTypeById } = useGetters('assets', [
  'getConditionById',
])
const { getByConditionId: getInventoryTypeBySubTypeId } = useGetters('assets', [
  'getByConditionId',
])
const queryClient = useQueryClient()

const getLocationById = (id) => {
  return queryClient.fetchQuery({
    queryKey: ['locations', id],
    queryFn: ({ signal }) => getById(id, signal),
    staleTime: moment.duration(10, 'minutes').asMilliseconds(),
  })
}

const valueAsString = ref<string>('')

const calculateStringValue = async (): Promise<string> => {
  if (props.value === true) {
    return 'Yes'
  } else if (props.value === false) {
    return 'No'
  }
  switch (props.lookup.entity) {
    case 'user':
      return getUserBySid.value(props.value)?.name ?? 'Unknown user'
    case 'company':
      return getCompanyById.value(props.value)?.name ?? 'Unknown company'
    case 'location':
      return (await getLocationById(props.value)).location ?? 'Unknown location'
    case 'business_unit':
      return getBusinessById.value(props.value)?.name ?? 'Unknown business unit'
    case 'inventory_sub_type':
      return (
        `${
          getInventorySubTypeById.value(props.value)?.name ??
          'Unknown Inventory Item'
        } · ` +
        (getInventoryTypeBySubTypeId.value(props.value)?.name ??
          'Unknown Inventory Type')
      )
    default:
      switch (props.format) {
        case 'date':
          return formatDateWithYear(props.value)
        case 'date-time':
          return formatDateTime(props.value)
        default:
          return props.value as string
      }
  }
}

watch(
  () => props,
  async () => {
    valueAsString.value = await calculateStringValue()
  },
  { deep: true, immediate: true }
)

return { __sfc: true,props, getUserBySid, getCompanyById, getBusinessById, getInventorySubTypeById, getInventoryTypeBySubTypeId, queryClient, getLocationById, valueAsString, calculateStringValue }
}

})